import { getPiece, getNextMove, isInPlayingArea } from './helpers';
import { INVALID_MOVE } from 'boardgame.io/core';
import {
  ENTERING_SPACE,
  RACK,
  CAPTURED,
  MAX_TILES_IN_ENTERING_SPACE,
} from '../constants';

export function cycleToEnteringSpace(G, ctx, pieceId) {
  const piece = getPiece(G.pieces, pieceId);
  const nextMove = getNextMove(piece);

  if (nextMove !== RACK) return INVALID_MOVE;

  if (G.enteringSpace[piece.color].length === MAX_TILES_IN_ENTERING_SPACE)
    return INVALID_MOVE;

  G.enteringSpace[piece.color].push(pieceId);
  if (isInPlayingArea(piece.currentPos)) G.cells[piece.currentPos] = null;
  piece.currentPos = ENTERING_SPACE;
}

export function cycleToRack(G, ctx, pieceId) {
  const piece = getPiece(G.pieces, pieceId);
  const nextMove = getNextMove(piece);

  if (nextMove !== RACK) return INVALID_MOVE;

  if (isInPlayingArea(piece.currentPos)) G.cells[piece.currentPos] = null;
  piece.currentPos = RACK;
}

export function movePiece(G, ctx, pieceID) {
  const piece = getPiece(G.pieces, pieceID);
  const space = G.enteringSpace[piece.color];

  // make sure they're moving their own piece
  if (piece.color !== ctx.currentPlayer) return INVALID_MOVE;
  const nextMove = getNextMove(piece);

  // end of cycle. nextMove is invalid, should call cycleToRack or cycleToEnteringSpace instead.
  if (nextMove === RACK) return INVALID_MOVE;

  // leaving the entering space stack (right now assuming it's a valid move)
  if (piece.currentPos === ENTERING_SPACE) {
    if (space.indexOf(pieceID) === space.length - 1) {
      if (
        G.cells[nextMove] !== null &&
        getPiece(G.pieces, G.cells[nextMove]).color === piece.color
      ) {
        return INVALID_MOVE;
      }
      space.pop();
    } else {
      // is the piece not at the top of the stack? if so, its an invalid move
      return INVALID_MOVE;
    }
  }

  const originalPos = piece.currentPos;

  if (isInPlayingArea(nextMove) && G.cells[nextMove] !== null) {
    // the piece is occupied. if it's the same color, it's invalid.
    // if it's the opposite color, capture.
    const occupiedPieceId = G.cells[nextMove];
    const occupiedPiece = getPiece(G.pieces, occupiedPieceId);

    if (occupiedPiece.color === piece.color) return INVALID_MOVE;
    else {
      occupiedPiece.currentPos = CAPTURED;
    }
  }

  if (isInPlayingArea(originalPos)) G.cells[originalPos] = null;

  // entering the entering space stack
  if (nextMove === ENTERING_SPACE) {
    if (space.length >= MAX_TILES_IN_ENTERING_SPACE) return INVALID_MOVE;
    space.push(piece.id);
  }

  if (isInPlayingArea(nextMove)) G.cells[nextMove] = piece.id;
  piece.currentPos = nextMove;
}
